<template>
  <div class="container-fluid">
    <div class="row">
      <div class="col-12">
        <div class="page-table-header full-height-page-wrapper">
          <PageHeader showBreadcrumbs :page-title="'Partners Telegram'">
            <template v-slot:buttons>
              <b-button
                class="button title-container__controls-item"
                :variant="isShowFilter ? 'secondary' : 'info'"
                @click="toggleShowFilter"
              >
                <span class="material-icons icon-image-preview">
                  tune
                </span>
                Filters
              </b-button>
            </template>
          </PageHeader>

          <Filters
            v-show="isShowFilter"
            textButtonSubmit="Filter"
            :data="getTableFilters"
            :isLoading="isDataPageLoading && isInitialDataLoaded"
            @submit="setFilters"
          />

          <div v-if="isDataPageLoading && !isInitialDataLoaded" class="content-loading-wrapper">
            <Preloader class="centered-preloader" />
          </div>

          <div v-else class="full-height-content">
            <TableForPage
              v-if="getTableData.length > 0"
              ref="table"
              :isDataLoading="isDataPageLoading && isInitialDataLoaded"
              :tableData="getTableData"
              :fields="getTableFields"
              :perPage="getPartnerTelegrams.per_page"
              :currentPage="getPartnerTelegrams.current_page"
              :totalRows="getPartnerTelegrams.total"
              :actions="getTableActions"
              isServerRender
              noLocalSorting
              @remove="remove"
              @edit="showEditModal"
              @update="updateList"
            />
            <EmptyStateNoResults
              v-else-if="isInitialDataLoaded && !getTableData.length"
              title="No partners yet"
              description="Add partners to manage all clients and business contacts in one place."
              customIcon="partner_exchange"
              customIconClasses="material-symbols-outlined empty-state__icon"
              :withoutButton="true"
            />
          </div>
        </div>
      </div>
    </div>

    <EditePartnerTelegramModal
      v-model="editModal.show"
      :form="editModal.form"
      :isLoading="isEditModalLoading"
      @save="edit"
    />
  </div>
</template>

<script>
import PageHeader from '@components/PageHeader'
import Filters from '@components/Filter/Filter'
import TableForPage from '@tables/TableForPage'
import { mapGetters } from 'vuex'
import TelegramPartnersMixin from '@mixins/notifications/TelegramPartnersMixin'
import EditePartnerTelegramModal from '@components/modals/Telegram/EditePartnerTelegramModal'
import Preloader from '@components/Preloader'
import EmptyStateNoResults from '@components/EmptyStateNoResults.vue'

export default {
  mixins: [TelegramPartnersMixin],
  components: {
    PageHeader,
    EditePartnerTelegramModal,
    Filters,
    TableForPage,
    Preloader,
    EmptyStateNoResults
  },
  data () {
    return {
      isAllOptionsFilterSet: false,
      isTelegramPartnersDataLoaded: false,
      isEditModalLoading: false
    }
  },
  created () {
    this.fetchAllData()
  },
  computed: {
    isInitialDataLoaded () {
      return this.isAllOptionsFilterSet && this.isTelegramPartnersDataLoaded
    },
    ...mapGetters({
      getPartnerTelegrams: 'telegram/getPartnerTelegrams'
    }),
    getTableFilters () {
      return this.filters || {}
    },
    getTableFields () {
      return this.table.fields || []
    },
    getTableActions () {
      return this.table.actions || []
    },
    getTableData () {
      return this.getPartnerTelegrams.data || []
    }
  },
  methods: {
    fetchAllData () {
      this.isAllOptionsFilterSet = true
      return Promise.all([
        this.fetchList()
      ])
    },
    fetchList () {
      let params = this.table.params.currentPage
      if (this.table.params.sorting) {
        params += this.table.params.sorting
      }
      if (this.table.params.filters) {
        params += this.table.params.filters
      }
      return this._toggleDataPageLoading(() => this.$api.telegram.getPartnerTelegrams(params)).then((result) => {
        this.isTelegramPartnersDataLoaded = true
        return result
      })
    },
    updateList (data) {
      if (!data) return this.fetchList()

      const { currentPage, sortDesc, sortBy } = data
      this.setParamsCurrentPage(currentPage)
      this.setParamsSort(sortDesc, sortBy)
      this.fetchList()
    },
    setFilters (data) {
      this.setParamsFilters(data)
      this.setParamsCurrentPage()
      this.fetchList()
    },
    edit (data) {
      this.isEditModalLoading = true
      const partnerTelegram = {
        partner_id: this.editModal.partnerId,
        ...this.prepareDataForRequest(data)
      }
      this.$api.telegram.editPartnerTelegram(partnerTelegram)
        .then(() => {
          this.$snotify.success('Partner telegram successfully edited', 'Success', this.$store.state.snotify)
          this.hideEditModal()
          this.fetchList()
        }).catch(err => {
          this.errorNotifications(err)
        })
        .finally(() => {
          this.isEditModalLoading = false
        })
    },
    async remove (item) {
      const confirm = await this.$root.$confirm.open(
        'Reset',
        'Are you sure you want to reset the partner telegram?'
      )

      if (!confirm) return

      this._toggleDataPageLoading(async () => {
        const deleteResponse = await this.$api.telegram.removePartnerTelegram(item.partnerId)
        this.$snotify.success(
          deleteResponse.data,
          'Success',
          this.$store.state.snotify
        )
        this.updateList()
      })
    }
  }
}
</script>
